/** @flow */

import {
  GetClientStaffGroupsSuccess,
  GetClientStaffGroupsError,
} from "@modules/shared/constants/actions";
import * as staffGroupsReducers from "./reducers";
import initialState from "./state";
import type { StaffGroupsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: StaffGroupsState = initialState, action: Object): Object => {
  const act = {
    [GetClientStaffGroupsSuccess]: staffGroupsReducers.onGetClientStaffGroupsSuccess,
    [GetClientStaffGroupsError]: staffGroupsReducers.onGetClientStaffGroupsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
